import './src/styles/global.css';
// コンテキストフックSearchContext設定用コード
import React from "react"
import { SearchContext, SearchContextProvider, useSearchContext } from "./src/context/SearchContext"
import Layout from './src/components/layout';

export const wrapRootElement = ({ element }) => (
  <SearchContextProvider>{element}</SearchContextProvider>
)

export const wrapPageElement = ({ element, props }) => {
  // props には pageContext, location などが含まれます
  // element は各ページのコンテンツです
  return <Layout {...props}>{element}</Layout>;
};

export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    `This tutorial has been updated. ` +
    `Reload to display the latest version?`
  )
  if (answer === true) {
    window.location.reload()
  }
}

// ✅ サイドバーがスクロールトップに戻らないようにする
export const shouldUpdateScroll = ({
  routerProps: { location }, // 現在のlocationを取得
}) => {
  console.log(`shouldUpdateScroll: Navigating to ${location.pathname}. Scrolling page to top.`);
  return [0, 0];
};


